export default "__VITE_ASSET__NKQ5wXBI__"